export const SUPPORTED_LANGUAGES = [
  { code: 'ka', label: 'KA', name: 'ქართული' },
  { code: 'en', label: 'EN', name: 'English' },
];

export const DEFAULT_LANGUAGE = 'ka';

const translations = {
  ka: {
    nav: {
      product: 'პროდუქტი',
      howItWorks: 'როგორ მუშაობს',
      partner: 'პარტნიორობა',
      download: 'ჩამოტვირთე აპი',
    },
    hero: {
      badge: 'თანამშრომელთა ბენეფიტების პლატფორმა',
      titleLine1: 'შენი თანამშრომლების ბენეფიტი,',
      titleLine2: 'ერთ ადგილას',
      sub: 'Loysta-ს მეშვეობით შენი გუნდი მაშინვე იღებს წვდომას ექსკლუზიურ ფასდაკლებებზე, ლოკალურ შეთავაზებებსა და დონეების მიხედვით ბენეფიტებზე — პირდაპირ მათ ტელეფონზე.',
      storeApple: 'ჩამოტვირთე',
      storeAppleName: 'App Store-ზე',
      storeAndroid: 'მიიღე',
      storeAndroidName: 'Google Play-ზე',
      trustFree: 'უფასო თანამშრომლებისთვის',
      trustPlatforms: 'iOS და Android',
      trustNoCard: 'საკრედიტო ბარათი საჭირო არ არის',
    },
    stats: {
      vendors: 'პარტნიორი ვენდორი',
      employees: 'აქტიური თანამშრომელი',
      companies: 'მომსახურებული კომპანია',
    },
    whatIs: {
      label: 'რა არის Loysta',
      titleLine1: 'ბენეფიტი, რომელსაც',
      titleLine2: 'რეალურად იყენებენ',
      body: 'Loysta არის თანამშრომელთა ბენეფიტების აპლიკაცია, რომელიც აკავშირებს შენს გუნდს ასობით ლოკალური და ეროვნული ვენდორის ექსკლუზიურ შეთავაზებებთან. თანამშრომლები ათვალიერებენ, იყენებენ და ზოგავენ — ყველაფერი მათი ტელეფონიდან.',
      pills: [
        'ექსკლუზიური შეთავაზებები შერჩეული ლოკალური და ეროვნული ვენდორებისგან',
        'დონეებზე დაფუძნებული წვდომა — უკეთესი ბენეფიტი წინსვლისას',
        'მყისიერი QR გამოყენება, ბეჭდვის გარეშე',
        'HR-ის მართვით, კონფიდენციალური და უსაფრთხო',
      ],
      cardTitle: 'შექმნილია მთელი ორგანიზაციისთვის',
      cardSub: 'Loysta ერთი პლატფორმის ქვეშ აერთიანებს სამ აუდიტორიას, თითოეულს თავისი გამოცდილებით.',
      types: {
        employees:    { name: 'თანამშრომლები', desc: 'დაათვალიერე და გამოიყენე ბენეფიტი აპლიკაციიდან' },
        admins:       { name: 'HR და ადმინისტრატორები', desc: 'მართე დონეები, წვდომა და ვენდორთა ქსელი' },
        vendors:      { name: 'ვენდორები და პარტნიორები', desc: 'მიაღწიე ჩართულ თანამშრომლებს რეალური ინტერესით' },
      },
    },
    features: {
      label: 'ძირითადი ფუნქციები',
      title: 'ყველაფერი, რაც გუნდს სჭირდება',
      items: [
        { title: 'შერჩეული ვენდორის შეთავაზებები',  body: 'დაათვალიერე ფიტნესის, კვების, საცალო ვაჭრობის, გართობისა და მოგზაურობის შეთავაზებები — რეგულარულად განახლდება.' },
        { title: 'დონეებზე დაფუძნებული ბენეფიტი', body: 'მიიღე უკეთესი ბენეფიტი წინსვლისას. HR-ის მიერ მართული დონეები უზრუნველყოფს, რომ შესაბამისმა თანამშრომლებმა მიიღონ შესაბამისი შეთავაზებები.' },
        { title: 'მყისიერი QR გამოყენება',         body: 'ბეჭდვა ან ვაუჩერი არ არის საჭირო. აჩვენე QR კოდი ვენდორთან და გადამოწმდება წამებში.' },
      ],
    },
    appScreens: {
      label: 'აპლიკაცია',
      title: 'ნახე მოქმედებაში',
      browseTitle: 'დაათვალიერე შეთავაზებები',
      browseSub: 'შერჩეული შეთავაზებები, ყოველთვის განახლებული',
      benefitsTitle: 'გამოიკვლიე ბენეფიტი',
      benefitsSub: 'კატეგორიების მიხედვით დალაგებული',
      redeemTitle: 'გამოიყენე მყისიერად',
      redeemSub: 'ერთი შეხება, ერთი სკანი, მზადაა',
    },
    howItWorks: {
      label: 'როგორ მუშაობს',
      title: 'წუთებში დაიწყე მუშაობა',
      steps: [
        { title: 'შენი კომპანია უერთდება', body: 'შენი HR გუნდი რეგისტრირდება და აერთებს კომპანიას. ისინი ირჩევენ ვენდორთა ქსელს და აყენებენ დონეებზე წვდომას ყველა თანამშრომლისთვის.' },
        { title: 'მიიღებ მოწვევას', body: 'თანამშრომლები იღებენ მოწვევას ელფოსტით ან SMS-ით. ჩამოტვირთე აპლიკაცია, შედი სამუშაო ავტორიზაციით და მზადაა.' },
        { title: 'დაიწყე დაზოგვა', body: 'დაათვალიერე შეთავაზებები, აღმოაჩინე კატეგორიები, ასკანერე QR კოდი სალაროზე და მყისიერად ისარგებლე ბენეფიტით.' },
      ],
    },
    partner: {
      label: 'გახდი Loysta-ს პარტნიორი',
      title: 'შემოუერთდი Loysta-ს ქსელს',
      sub: 'იქნები კომპანია, რომელსაც გუნდისთვის უკეთესი ბენეფიტი სურს, თუ ვენდორი, რომელიც ცდილობს ათასობით თანამშრომელს მიაწოდოს შერჩეული შეთავაზებები — სიამოვნებით მოგისმენთ.',
      companyTitle: 'დარეგისტრირდი როგორც კომპანია',
      companyBody: 'დაარეგისტრირე თანამშრომლები Loysta-ზე. დააკონფიგურირე დონეებზე დაფუძნებული ბენეფიტი, მართე ცენტრალურად და დააკვირდი ჩართულობას.',
      companyBullets: ['უფასო თანამშრომლებისთვის', '3-დონიანი ბენეფიტების სისტემა', 'ადაპტაციის მხარდაჭერა'],
      companyCta: 'დარეგისტრირდი როგორც კომპანია',
      vendorTitle: 'დარეგისტრირდი როგორც ვენდორი',
      vendorBody: 'მიაღწიე ათასობით თანამშრომელს Loysta-ს ქსელში. შექმენი შეთავაზებები, ასკანერე QR კოდი სალაროზე, თვალი ადევნე გამოყენებას.',
      vendorBullets: ['დონეების მიხედვით მიზანმიმართული შეთავაზებები', 'ჩაშენებული QR გამოყენება', 'ვენდორის პორტალი'],
      vendorCta: 'დარეგისტრირდი როგორც ვენდორი',
    },
    download: {
      label: 'ხელმისაწვდომია ახლა',
      titleLine1: 'მიიღე Loysta უფასოდ',
      titleLine2: 'შენს ტელეფონზე',
      sub: 'ხელმისაწვდომია iOS-სა და Android-ზე. უფასო ყველა თანამშრომლისთვის.',
    },
    footer: {
      copy: 'ყველა უფლება დაცულია.',
      privacy: 'კონფიდენციალურობა',
      terms: 'წესები და პირობები',
      contact: 'კონტაქტი',
    },
    apply: {
      pillCompany: 'კომპანიის განაცხადი',
      pillVendor: 'ვენდორის განაცხადი',
      titleCompany: 'დარეგისტრირდი როგორც კომპანია',
      titleVendor: 'დარეგისტრირდი როგორც ვენდორი',
      subCompany: 'დაარეგისტრირე გუნდი Loysta-ზე — ექსკლუზიური ბენეფიტი და დონეების სისტემა, რამდენიმე დღეში მზად.',
      subVendor: 'მიაღწიე ათასობით თანამშრომელს Loysta-ს ქსელში შერჩეული შეთავაზებებით.',
      nameCompany: 'კომპანიის სახელი *',
      nameCompanyPh: 'მაგ. Acme Corporation',
      nameVendor: 'ბიზნესის სახელი *',
      nameVendorPh: 'მაგ. Coffee House Georgia',
      descCompany: 'მოგვიყევი შენი კომპანიის შესახებ *',
      descCompanyPh: 'რას აკეთებ, გუნდის ზომა, ნებისმიერი დეტალი რაც უნდა ვიცოდეთ.',
      descVendor: 'მოგვიყევი შენი ბიზნესის შესახებ *',
      descVendorPh: 'კატეგორია (კვება, ფიტნესი, საცალო…), ლოკაციები, რის შეთავაზებას გეგმავ.',
      contact: 'საკონტაქტო პირი *',
      contactPh: 'სახელი და გვარი',
      email: 'ელფოსტა *',
      emailPh: 'you@company.com',
      phone: 'ტელეფონი *',
      phonePh: '+995 5XX XXX XXX',
      submit: 'გაგზავნე განაცხადი',
      submitting: 'იგზავნება…',
      success: 'განაცხადი გაგზავნილია! ჩვენი გუნდი დაგიკავშირდება 1–2 სამუშაო დღეში.',
      successHeading: 'მადლობა — მივიღეთ!',
      close: 'დახურვა',
      errorRequired: 'გთხოვ შეავსე ყველა ველი.',
      errorEmail: 'გთხოვ შეიყვანე სწორი ელფოსტის მისამართი.',
      errorGeneric: 'ვერ გავგზავნეთ. გთხოვ სცადე ხელახლა.',
      footerNote: 'ჩვენი გუნდი განიხილავს განაცხადს და დაგიკავშირდება ელფოსტით 1–2 სამუშაო დღეში.',
    },
  },

  en: {
    nav: {
      product: 'Product',
      howItWorks: 'How it works',
      partner: 'Partner with us',
      download: 'Download the App',
    },
    hero: {
      badge: 'Employee Benefits Platform',
      titleLine1: 'Your employee perks,',
      titleLine2: 'all in one place',
      sub: 'Loysta gives your team instant access to exclusive discounts, local deals, and tier-based perks — delivered straight to their phone.',
      storeApple: 'Download on the',
      storeAppleName: 'App Store',
      storeAndroid: 'Get it on',
      storeAndroidName: 'Google Play',
      trustFree: 'Free for employees',
      trustPlatforms: 'iOS & Android',
      trustNoCard: 'No credit card needed',
    },
    stats: {
      vendors: 'Partner Vendors',
      employees: 'Active Employees',
      companies: 'Companies Served',
    },
    whatIs: {
      label: 'What is Loysta',
      titleLine1: 'Benefits employees',
      titleLine2: 'actually use',
      body: 'Loysta is an employee benefits app that connects your workforce with exclusive deals and discounts from hundreds of local and national vendors. Employees browse, redeem, and save — all from their phone.',
      pills: [
        'Exclusive deals from vetted local & national vendors',
        'Tier-based access — better perks as you progress',
        'Instant QR redemption, no printouts needed',
        'Managed by HR, private and secure',
      ],
      cardTitle: 'Built for your whole organisation',
      cardSub: 'Loysta connects three audiences under one platform, each with their own dedicated experience.',
      types: {
        employees: { name: 'Employees',           desc: 'Browse and redeem perks from the app' },
        admins:    { name: 'HR & Admins',         desc: 'Manage tiers, access and vendor network' },
        vendors:   { name: 'Vendors & Partners',  desc: 'Reach engaged employees with real intent' },
      },
    },
    features: {
      label: 'Key Features',
      title: 'Everything your team needs',
      items: [
        { title: 'Curated Vendor Offers', body: 'Browse handpicked deals across fitness, dining, retail, entertainment, and travel — refreshed regularly to keep things fresh.' },
        { title: 'Tier-Based Perks',      body: 'Unlock better perks as you progress. HR-managed tiers ensure the right employees get access to the right offers.' },
        { title: 'Instant QR Redemption', body: "No printouts or vouchers. Show your personal QR code at the vendor checkout and it's verified in seconds." },
      ],
    },
    appScreens: {
      label: 'The App',
      title: 'See it in action',
      browseTitle: 'Browse Offers',
      browseSub: 'Curated deals, always up to date',
      benefitsTitle: 'Explore Benefits',
      benefitsSub: 'Organised by category',
      redeemTitle: 'Redeem Instantly',
      redeemSub: 'One tap, one scan, done',
    },
    howItWorks: {
      label: 'How It Works',
      title: 'Up and running in minutes',
      steps: [
        { title: 'Your company joins', body: 'Your HR team signs up and connects your company. They curate the vendor network and configure tier access for all employees.' },
        { title: 'You get invited',    body: "Employees receive an invite via email or SMS. Download the app, sign in with your work credentials, and you're in." },
        { title: 'Start saving',       body: 'Browse offers, discover deals across categories, scan your QR code at checkout, and enjoy your perks instantly.' },
      ],
    },
    partner: {
      label: 'Partner with Loysta',
      title: 'Join the Loysta network',
      sub: "Whether you're a company looking to give your team better perks, or a vendor wanting to reach thousands of employees with curated offers — we'd love to hear from you.",
      companyTitle: 'Apply as a Company',
      companyBody: 'Get your employees onto Loysta. Configure tier-based perks, manage benefits centrally, and watch engagement.',
      companyBullets: ['Free for employees', '3-tier benefit system', 'Onboarding support'],
      companyCta: 'Apply as a Company',
      vendorTitle: 'Apply as a Vendor',
      vendorBody: 'Reach thousands of employees across the Loysta network. Create offers, scan QR codes at checkout, track redemptions.',
      vendorBullets: ['Tier-targeted offers', 'Built-in QR redemption', 'Vendor portal'],
      vendorCta: 'Apply as a Vendor',
    },
    download: {
      label: 'Available Now',
      titleLine1: 'Get Loysta free',
      titleLine2: 'on your phone',
      sub: 'Available for iOS and Android. Free for all employees.',
    },
    footer: {
      copy: 'All rights reserved.',
      privacy: 'Privacy',
      terms: 'Terms',
      contact: 'Contact',
    },
    apply: {
      pillCompany: 'Company application',
      pillVendor: 'Vendor application',
      titleCompany: 'Apply as a Company',
      titleVendor: 'Apply as a Vendor',
      subCompany: 'Get your team onto Loysta — exclusive perks and tier-based benefits, ready in days.',
      subVendor: 'Reach thousands of employees across the Loysta network with curated offers.',
      nameCompany: 'Company name *',
      nameCompanyPh: 'e.g. Acme Corporation',
      nameVendor: 'Business name *',
      nameVendorPh: 'e.g. Coffee House Georgia',
      descCompany: 'Tell us about your company *',
      descCompanyPh: 'What you do, team size, anything we should know.',
      descVendor: 'Tell us about your business *',
      descVendorPh: 'Category (food, fitness, retail…), locations, what you want to offer.',
      contact: 'Contact person *',
      contactPh: 'Full name',
      email: 'Email *',
      emailPh: 'you@company.com',
      phone: 'Phone *',
      phonePh: '+995 5XX XXX XXX',
      submit: 'Submit application',
      submitting: 'Submitting…',
      success: 'Application submitted! Our team will reach out within 1–2 business days.',
      successHeading: 'Thanks — we got it!',
      close: 'Close',
      errorRequired: 'Please fill in every field.',
      errorEmail: 'Please enter a valid email address.',
      errorGeneric: 'Could not submit. Please try again.',
      footerNote: 'Our team will review your application and reach out by email within 1–2 business days.',
    },
  },
};

export default translations;
